import type { EgsBeddingType, EgsCategoryMeta, EgsCollectedBy, EgsGuestType, EgsRateType } from './types';

export const EGS_CATS: Array<EgsCategoryMeta> = [
  {
    key: 'adult',
    guestType: 'extra_adult',
    label: 'Adult',
    question: 'Can this room accommodate at least 1 Extra Adult?',
    ages: 'from',
  },
  {
    key: 'child',
    guestType: 'extra_child',
    label: 'Child',
    question: 'Can this room accommodate at least 1 Extra Child?',
    ages: 'both',
  },
  {
    key: 'infant',
    guestType: 'extra_infant',
    label: 'Infant',
    question: 'Can this room accommodate at least 1 Extra Infant?',
    ages: 'to',
  },
];

export const EGS_GUEST_TYPE_LABELS: Record<EgsGuestType, string> = {
  extra_adult: 'Extra Adult',
  extra_child: 'Extra Child',
  extra_infant: 'Extra Infant',
};

export const EGS_COLLECTED_BY_LABELS: Record<EgsCollectedBy, string> = {
  free_of_charge: 'Free of Charge',
  paid_at_booking: 'Paid at Booking Stage',
};

export const EGS_BEDDING_LABELS: Record<EgsBeddingType, string> = {
  existing_bedding: 'Existing Bedding (Part of Standard Bedding Config)',
  cot: 'Cot',
  rollaway_bed: 'Rollaway bed',
  daybed: 'Daybed',
  single_sofa_bed: 'Single sofa bed',
  double_sofa_bed: 'Double sofa bed',
  other: 'Other',
};

export const EGS_RATE_TYPE_LABELS: Record<EgsRateType, string> = {
  per_stay: 'Per Stay',
  daily_rate: 'Daily Rate',
};

export const EGS_BEDDING_OPTIONS: Array<{ label: string; value: EgsBeddingType }> = [
  { value: 'existing_bedding', label: EGS_BEDDING_LABELS.existing_bedding },
  { value: 'cot', label: EGS_BEDDING_LABELS.cot },
  { value: 'rollaway_bed', label: EGS_BEDDING_LABELS.rollaway_bed },
  { value: 'daybed', label: EGS_BEDDING_LABELS.daybed },
  { value: 'single_sofa_bed', label: EGS_BEDDING_LABELS.single_sofa_bed },
  { value: 'double_sofa_bed', label: EGS_BEDDING_LABELS.double_sofa_bed },
  { value: 'other', label: EGS_BEDDING_LABELS.other },
];

export const EGS_RATE_TYPE_OPTIONS: Array<{ label: string; value: EgsRateType }> = [
  { value: 'per_stay', label: EGS_RATE_TYPE_LABELS.per_stay },
  { value: 'daily_rate', label: EGS_RATE_TYPE_LABELS.daily_rate },
];
